import { render, staticRenderFns } from "./Xin.vue?vue&type=template&id=38a50ad1&scoped=true&"
import script from "./Xin.vue?vue&type=script&lang=js&"
export * from "./Xin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a50ad1",
  null
  
)

export default component.exports